import { formatString, removeUnderscores } from "./utils";

/**
 * Extracts and formats the user's organization/domain name from localStorage.
 * - Retrieves the 'livis_user_info' object from localStorage.
 * - Parses the email to extract the domain part before the first dot.
 * - Replaces hyphens with spaces, removes underscores, and formats the string.
 * - Returns the formatted organization name prefixed with " | ".
 * - If not found, returns " | LIVIS".
 *
 * @returns Formatted organization/domain string for display.
 */
export const findUser = (): any => {
  try {
    const raw = localStorage.getItem("livis_user_info");
    if (!raw) return " | LIVIS";

    const user_info = JSON.parse(raw);
    const email: string | undefined = user_info?.email;
    if (!email) return " | LIVIS";

    const domain = email.split("@")?.[1]?.split(".")?.[0]?.replace(/-/g, " ");
    if (!domain) return " | LIVIS";

    return " | " + removeUnderscores(formatString(domain));
  } catch {
    return " | LIVIS";
  }
};
